<template>
  <EHSModal
    :primaryActionFunction="onModalClose"
    :headerTitle="$t('Button.attachments')"
    :primaryButtonText="$t('Button.OK')"
    class="ehs-modal"
  >
    <Layout center h-sm p-2 vld-parent>
      <Loading
        :active.sync="loading"
        :canCancel="false"
        :isFullPage="false"
        backgroundColor="#f0f0f0"
        loader="bars"
      />
      <FileList
        v-if="fileListSetupComplete && !loading"
        :value="fileList"
        :service="fileService"
        :maxFileSize="maxFileSize"
        :acceptedExtensions="acceptedExtensions"
      />
    </Layout>
  </EHSModal>
</template>

<script>
import Layout from '@wizer/core/components/layout/Layout'
import FileList from '@wizer/core/components/file-list/FileList'
import Loading from 'vue-loading-overlay'
import EHSModal from '@/components/EHSModal'
import SustainabilityAttachmentService from '@/services/SustainabilityAttachmentService'
import AttachmentMixin from '@/mixins/AttachmentMixin'

export default {
  name: 'AttachmentDialog',
  mixins: [AttachmentMixin],
  components: {
    Layout,
    FileList,
    Loading,
    EHSModal,
  },
  props: {
    parentRecordId: String,
  },
  data() {
    return {
      loading: false,
      fileList: [],
      fileService: SustainabilityAttachmentService,
    }
  },
  mounted() {
    this.loading = true
    this.getFileList()
  },
  methods: {
    async getFileList() {
      this.fileList = (
        await SustainabilityAttachmentService.getFileList(this.parentRecordId)
      ).data.items.map((file) => ({
        id: file.id,
        label: file.fileName,
        downloadLink: file.downloadLink,
      }))
      this.loading = false
    },
    async onModalClose() {
      await this.refreshFileList()
      this.$emit('close')
    },
    async refreshFileList() {
      await this.getFileList()
      if (this.fileList.length) {
        this.$emit('fileListUpdated')
      }
    },
  },
}
</script>

<style>
.ehs-modal .w-file-list__remove {
  display: none;
}
.ehs-modal .w-layout {
  height: 100%;
}
</style>
